<script lang="ts" setup>
import { type PropType } from '#imports';
import type { UserMessageVo } from '@core/types/auto/forum';

defineProps({
  msg: {
    type: Object as PropType<UserMessageVo>,
    default: () => ({}),
  },
});
</script>

<template>
  <div class="font-semibold">
    <span>{{ msg.messageContent }}</span>
    <span v-if="msg.messageType === 2" class="ml-1">回复了你</span>
  </div>
</template>

<style scoped></style>
